import noop from 'lib/noop'
import React from 'react'

type SaveClickHanlder = () => void

export const RecommendationSaveClickTrackerContext = React.createContext<SaveClickHanlder>(noop)
